import { Component } from '@angular/core';

@Component({
  selector: 'app-product-materials-detail',
  standalone: false,
  
  templateUrl: './product-materials-detail.component.html',
  styles: ``
})
export class ProductMaterialsDetailComponent {

}
